export type LinkConfigEntry = {
  action: string // The action to be performed
  path: string // React Router path (can include :params)
  requiresAuth: boolean // Whether the link requires authentication
  paramKeys?: readonly string[] // Optional array of param keys
}

export const LinkConfig: Record<string, LinkConfigEntry> = {
  'change-email': {
    action: 'change-email',
    path: '/profile/information',
    requiresAuth: true,
  },
  'payment-status': {
    action: 'payment-status',
    path: '/payment-status',
    requiresAuth: false,
  },
  tasks: {
    action: 'tasks',
    path: '/task',
    requiresAuth: true,
  },
  'task-detail': {
    action: 'task-detail',
    path: '/task/:id',
    requiresAuth: true,
    paramKeys: ['id'],
  },
  messages: {
    action: 'messages',
    path: '/message',
    requiresAuth: true,
  },
  'message-detail': {
    action: 'message-detail',
    path: '/message/:id',
    requiresAuth: true,
    paramKeys: ['id'],
  },
  documents: {
    action: 'documents',
    path: '/documents/personal',
    requiresAuth: true,
  },
  agenda: {
    action: 'agenda',
    path: '/timeline',
    requiresAuth: true,
  },
  appointment: {
    action: 'appointment',
    path: '/timeline/appointment/:id',
    requiresAuth: true,
    paramKeys: ['id'],
  },
  encounter: {
    action: 'encounter',
    path: '/timeline/encounter/:id',
    requiresAuth: true,
    paramKeys: ['id'],
  },
} as const
